(function() {
    'use strict';
    angular
        .module('consinfApp')
        .factory('VideoInformativo', VideoInformativo);

    VideoInformativo.$inject = ['$resource', 'DateUtils'];

    function VideoInformativo ($resource, DateUtils) {
        var resourceUrl =  'api/video-informativos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.validoDa = DateUtils.convertDateTimeFromServer(data.validoDa);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
